<template>
  <div class="pageCon">
    <HomePageTop ref="pagetop"></HomePageTop>

    <div class="bg1 ">
      <div class="bg1Con">
        <!-- 全流程一站式管家服务 -->
        <h3>{{ $fanyi("全流程一站式管家服务") }}</h3>
        <!-- Rakumart 跨境物流收费透明说明 -->
        <h1>{{ $fanyi("Rakumart 跨境物流收费透明说明") }}</h1>
        <div class="pBox">
          <!-- Rakumart 提供全链路托管，从源头采购到目的地清关，专业执行 -->
          <p>
            {{ $fanyi("Rakumart 提供全链路托管，从源头采购到目的地清关，专业执行") }}
          </p>
          <!-- 携手 Rakumart，重塑跨境采购与进口体验 -->
          <p>
            {{
              $fanyi(
                "携手 Rakumart，重塑跨境采购与进口体验",
              )
            }}
          </p>
          <!-- 高效优化供应链，显著降低综合成本 -->
          <p>{{ $fanyi("高效优化供应链，显著降低综合成本") }}</p>
        </div>
      </div>
    </div>
    <div style="position: relative;">
      <fixedMenu :textData="textData" @scrollToTop="scrollToTop" />
      <div class="whiteBg fontModel">
        <div class="modelCon" style="  position: relative;">
          <div class="fontConTitle">
            <!-- Rakumart跨境物流服务概览 -->
            <span>{{ $fanyi("Rakumart跨境物流服务概览") }}</span>
            <div class="line"></div>
          </div>
          <div class="pagetableBox tableBox  showLositiTable ">
            <div class="tul ttt">
              <!-- 运输 -->
              <div class="tli ttt ">{{ $fanyi("运输方式") }}</div>
              <!-- 最小体积 -->
              <div class="tli ttt ">{{ $fanyi("最小体积") }}</div>
              <!-- 最大体积 -->
              <div class="tli ttt ">{{ $fanyi("最大体积") }}</div>
              <!-- 运输时间* -->
              <div class="tli ttt ">{{ $fanyi("运输时间*") }}</div>
            </div>
            <div class="tul tbo">
              <!-- 空运 -->
              <div class="tli tbo fontWeight500">{{ $fanyi("空运") }}</div>
              <div class="tli tbo ">{{ $fanyi("无最低限制") }}</div>
              <div class="tli tbo ">{{ $fanyi("无最高限制") }}</div>
              <div class="tli tbo ">{{ $fanyi("约10-20天") }}</div>
            </div>
            <div class="tul tbo">
              <!-- 陆运 -->
              <div class="tli tbo fontWeight500">{{ $fanyi("陆运") }}</div>
              <div class="tli tbo ">21kg</div>
              <div class="tli tbo ">{{ $fanyi("无最高限制") }}</div>
              <div class="tli tbo ">{{ $fanyi("约35-45天") }}</div>
            </div>
            <div class="tul tbo">
              <!-- 海运 -->
              <div class="tli tbo fontWeight500">{{ $fanyi("海运") }}</div>
              <div class="tli tbo ">21kg</div>
              <div class="tli tbo ">{{ $fanyi("无最高限制") }}</div>
              <div class="tli tbo ">{{ $fanyi("约60-70天") }}</div>
            </div>
            <div class="tul tbo">
              <!-- 铁路货运 -->
              <div class="tli tbo fontWeight500">{{ $fanyi("铁路货运") }}</div>
              <div class="tli tbo ">21kg</div>
              <div class="tli tbo ">{{ $fanyi("无最高限制") }}</div>
              <div class="tli tbo ">{{ $fanyi("约45-55天") }}</div>
            </div>
          </div>
          <div class="fontConTip">
            {{
              $fanyi(
                "运输时间（Transit Time）仅指货物从起运地至目的地的实际在途运输时长。此数据仅供参考，实际送达时间可能受天气变化、海关查验、旺季物流与仓储压力等不可控因素影响。详情请参阅",
              )
            }}
            <span class="aLink" @click="goLogisticaEnvio">{{
              $fanyi("《Rakumart 物流运输指南》")
            }}</span
            >{{ $fanyi("。") }}
          </div>
        </div>
      </div>

      <div class="whiteBg fontModel pabo50">
        <div class="modelCon">
          <div class="fontConTitle">
            <!-- 物流运费估算 -->
            <span>{{ $fanyi("物流运费估算") }}</span>
            <div class="line"></div>
          </div>
          <div class="pagetableBox tableBox  calculateLogisticsTable">
            <div class="tul ttt">
              <!-- 实际重量 -->
              <div class="tli ttt ">{{ $fanyi("实际重量") }}</div>
              <!-- 长度 -->
              <div class="tli ttt ">{{ $fanyi("长度") }}</div>
              <!-- 宽度 -->
              <div class="tli ttt ">{{ $fanyi("宽度") }}</div>
              <!-- 高度 -->
              <div class="tli ttt ">{{ $fanyi("高度") }}</div>
              <!-- 箱子数量 -->
              <div class="tli ttt ">{{ $fanyi("箱子数量") }}</div>
              <!-- 总重量 -->
              <div class="tli ttt ">{{ $fanyi("总重量") }}</div>
              <div class="tli ttt" style="flex:0 0 60px;"></div>
            </div>
            <div class="tul tbo" v-for="(item, index) in oform" :key="index">
              <div class="tli tbo ">
                <el-input
                  :oninput="$fun.rejectIntNumbers"
                  class="logisticsInputBox"
                  @change="calculationLogisticsAmount()"
                  v-model="item.weight"
                  ><template slot="append"><span>KG</span></template></el-input
                >
              </div>
              <div class="tli tbo ">
                <el-input
                  :oninput="$fun.rejectIntNumbers"
                  class="logisticsInputBox"
                  v-model="item.length"
                  @change="calculationLogisticsAmount()"
                  ><template slot="append"><span>CM</span></template></el-input
                >
              </div>
              <div class="tli tbo ">
                <el-input
                  :oninput="$fun.rejectIntNumbers"
                  class="logisticsInputBox"
                  @change="calculationLogisticsAmount()"
                  v-model="item.width"
                  ><template slot="append"><span>CM</span></template></el-input
                >
              </div>
              <div class="tli tbo ">
                <el-input
                  :oninput="$fun.rejectIntNumbers"
                  class="logisticsInputBox"
                  v-model="item.height"
                  @change="calculationLogisticsAmount()"
                  ><template slot="append"><span>CM</span></template></el-input
                >
              </div>
              <div class="tli tbo ">
                <el-input
                  :oninput="$fun.rejectIntNumbers"
                  class="logisticsInputBox"
                  v-model="item.num"
                  @change="calculationLogisticsAmount()"
                  ><template slot="append"><span></span></template
                ></el-input>
              </div>
              <div class="tli tbo ">
                <el-input
                  class="logisticsInputBox totalWeightInput"
                  v-model="item.total_weight"
                  ><template slot="append"><span>KG</span></template></el-input
                >
              </div>
              <div class="tli tbo" style="flex:0 0 60px;">
                <img
                  :src="require('@/assets/icon/delete.png')"
                  alt=""
                  style="width: 17px;cursor:pointer"
                  @click="oform.splice(index, 1)"
                />
              </div>
            </div>
            <div class="addRow">
              <el-button class="bgGreenBtn" @click="oform.push({})">{{
                $fanyi("增加")
              }}</el-button>
              <div class="totalBox">
                {{ $fanyi("总计") }}：<b>{{ total_weight }}KG</b>
                <el-button
                  class="bgBlueBtn"
                  type="primary"
                  @click="
                    calcLoading = true;
                    calculationLogisticsAmount();
                  "
                  style="margin-left: 40px;"
                  :loading="calcLoading"
                >
                  {{ $fanyi("计算费用") }}
                </el-button>
              </div>
            </div>
          </div>

          <div class="pagetableBox tableBox  calculationResultsTable">
            <div class="tul ttt">
              <!-- 货运方式 -->
              <div class="tli ttt " style="flex: 0 0 190px;">
                {{ $fanyi("货运方式") }}
              </div>
              <!-- 类别 -->
              <div class="tli ttt " style="flex: 0 0 190px;">
                {{ $fanyi("类别") }}
              </div>
              <!-- 可计费重量 -->
              <div class="tli ttt ">
                {{ $fanyi("可计费重量") }} <br />
                (KG)
              </div>
              <!-- 国际运费(¥) -->
              <div class="tli ttt ">{{ $fanyi("国际运费(¥)") }}</div>
              <!-- 国际运费(€) -->
              <div class="tli ttt ">
                {{ $fanyi("国际运费(€)") }}
              </div>
              <!-- 时效 -->
              <div class="tli ttt ">{{ $fanyi("时效") }}</div>
              <div class="tli ttt " style="flex: 0 0 95px;"></div>
            </div>
            <div class="tul tbo" v-for="(item, index) in datas" :key="index">
              <!-- 货运方式 -->
              <div class="tli tbo texcen" style="flex: 0 0 190px;">
                {{ item.home_name }}
              </div>
              <!-- 类别 -->
              <div class="tli tbo " style="flex: 0 0 190px;">
                <div
                  class="logisticsNameColorBox"
                  :class="logisticsColor[index]"
                >
                  {{ item.prefix }}
                </div>
              </div>
              <!-- 可计费重量 -->
              <div class="tli tbo ">{{ item.charge_weight }}</div>
              <!-- 国际运费(¥) -->
              <div class="tli tbo ">
                {{ $fun.RMBNumSegmentation(item.international_freight_rmb) }}
              </div>
              <!-- 国际运费(€) -->
              <div class="tli tbo ">
                {{ $fun.EURNumSegmentation(item.international_freight_eu) }}
              </div>
              <!-- 时效 -->
              <div class="tli tbo ">{{ item.home_explain }}</div>
              <div class="tli tbo " style="flex: 0 0 95px;">
                <!-- 详情 -->
                <span class="aLink" @click="scrollToTop(index)">{{
                  $fanyi("详情")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fontModel pabo50 fdcolmun">
        <div class="modelCon">
          <div class="fontConTitle">
            <!-- 物流费用说明 -->
            <span>{{ $fanyi("物流费用说明") }}</span>
            <div class="line"></div>
          </div>
          <div
            class="whiteCard"
            v-for="(item, index) in textData"
            :key="index"
            :ref="item.home_name"
          >
            <div class="logisticsNameBox">{{ item.home_name }}</div>
            <div class="logisticsPriceList pagetableBox ">
              <div class="tul tbo">
                <!-- 重量 -->
                <div class="tli tbo blueTbo">{{ $fanyi("重量") }}</div>
                <div
                  class="tli tbo"
                  v-for="(range_item, range_index) in item.range"
                  :key="range_index"
                >
                  <span>{{ range_item.min }}～{{ range_item.max }}KG</span>
                </div>
              </div>
              <div class="tul tbo">
                <!-- 费用 -->
                <div class="tli tbo blueTbo">{{ $fanyi("费用") }}</div>
                <div
                  class="tli tbo"
                  v-for="(range_item, range_index) in item.range"
                  :key="range_index"
                >
                  {{ $fun.ceil(range_item.price * $store.state.exchangeRate) }}€
                  ({{ range_item.price }}￥)<span
                    v-if="range_item.chargePerMethod == 2"
                    >/KG</span
                  >
                </div>
              </div>
            </div>
            <div class="lastUpdatedDate">
              {{ $fanyi("最后更新日期") }}：{{ item.updated_at }}
            </div>
            <div class="deliveryTime">
              <!-- 交货期 -->
              <span>{{ $fanyi("交货期") }}</span
              ><b
                >{{ $fanyi("介于") }} {{ item.predict_duration }}
                {{ $fanyi("天") }}</b
              >
            </div>
            <div class="mattersNeedingAttention">
              <div
                v-html="isChinese ? item.note_cn || '' : item.note_en || ''"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="whiteBg fontModel pabo50">
        <div class="expertAgent pageMoudle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 24 24"
            style="enable-background: new 0 0 24 24"
            xml:space="preserve"
          >
            <path
              class="st0"
              d="M11.4,1C6.6,1.3,3,5.5,3,10.3V17c0,1.7,1.3,3,3,3h1c1.1,0,2-0.9,2-2v-4c0-1.1-0.9-2-2-2H5v-1.7 C5,6.4,8,3.1,11.8,3c4-0.1,7.2,3.1,7.2,7v2h-2c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2h2v1h-6c-0.6,0-1,0.5-1,1s0.4,1,1,1h5 c1.7,0,3-1.3,3-3V10C21,4.8,16.6,0.7,11.4,1z"
            ></path>
          </svg>
          <div class="expertAgentCon">
            <!-- 联系专业代理 -->
            <div>{{ $fanyi("联系专业代理") }}</div>
            <p>
              {{
                $fanyi(
                  "您是否正在寻找从中国进口的最佳解决方案？Rakumart是您的理想选择。我们负责从产品采购到送达收货地址的所有流程。立即联系专业代理，享受我们的全方位服务。",
                )
              }}
            </p>
            <!-- 联系代理人 -->
            <button @click="openChat">{{ $fanyi("联系代理人") }}</button>
          </div>
        </div>
      </div>
      <Foot style="width: 100%"></Foot>
    </div>
  </div>
</template>
<script>
import fixedMenu from "./components/fixedMenu.vue";
import HomePageTop from "@/components/head/HomePageTop.vue";
import Foot from "@/components/foot/Foot.vue";
export default {
  data() {
    return {
      logisticsColor: ["color1", "color2", "color3", "color4"],
      oform: [
        {
          weight: 1,
          length: 58,
          width: 50,
          height: 51,
          num: 1,
        },
      ],
      total_weight: 0,
      datas: [],
      textData: [],
      calcLoading: false,
    };
  },
  components: {
    HomePageTop,
    Foot,
    fixedMenu,
  },
  computed: {
    // 是否为中文模式，切换物流费用说明展示 note_cn / note_en
    isChinese() {
      return !!this.$store.state.fanyi;
    },
  },
  mounted() {},
  created() {
    this.calculationLogisticsAmount();
    this.logisticsAmountExplain();
    // 监听页面大小变动事件
    window.addEventListener("resize", this.getLocation);
  },
  methods: {
    openChat() {
      this.$fun.clickJs();
    },
    // 跳转物流与运输说明页
    goLogisticaEnvio() {
      this.$fun.routerToPage("/logistica-y-envio");
    },
    calculationLogisticsAmount() {
      let total_weight = 0;
      for (let index in this.oform) {
        this.oform[index].total_weight = this.$fun.ceil(
          (Number(this.oform[index].num) || 0) *
            (Number(this.oform[index].weight) || 0),
        );
        this.oform.splice(0, 0);
        total_weight += this.oform[index].total_weight;
      }
      this.total_weight = total_weight;

      // // 验证这五个参数都不为空的时候才调用接口
      let regArr = ["weight", "length", "width", "height", "num"];
      for (let i in this.oform) {
        for (let j in regArr) {
          if (!this.$fun.checkParams(this.oform[i][regArr[j]])) {
            return;
          }
        }
      }

      this.$api.calculationLogisticsAmount({ list: this.oform }).then((res) => {
        ////console.log('事件名',res)
        // if (res.code != 0)
        //   return this.$message.error(this.$fanyi(res.data.msg));
        //接下来的操作
        this.calcLoading = false;
        this.datas = res.data;
        if (this.textData.length) {
          this.getLocation();
        }
      });
    },
    logisticsAmountExplain() {
      this.$api.logisticsAmountExplain().then((res) => {
        ////console.log('事件名',res)
        // if (res.code != 0)
        //   return this.$message.error(this.$fanyi(res.data.msg));
        //接下来的操作

        res.data.forEach((item) => {
          // 接口返回的说明含 HTML 实体，统一替换为空格便于展示
          if (item.note_en) {
            item.note_en = item.note_en.replace(/&nbsp;/g, " ");
          }
          if (item.note_cn) {
            item.note_cn = item.note_cn.replace(/&nbsp;/g, " ");
          }
        });
        this.textData = res.data;
        setTimeout(() => {
          this.getLocation();
        }, 1000);
      });
    },

    // 获取位置
    getLocation() {
      let hArr = document.getElementsByClassName("logisticsNameBox");
      for (let i in this.textData) {
        let txtItem = this.textData[i];
        // console.log("元素高度", this.$refs[txtItem.name][0].offsetTop + 820);
        txtItem.offsetTop =
          (hArr[i].offsetTop + 520) * this.$store.state.roomNum;
      }
      // console.log(this.textData);
    },

    scrollToTop(index) {
      let hArr = document.getElementsByClassName("logisticsNameBox");
      window.scrollTo({
        behavior: "smooth", // 这个属性使页面滚动平滑，而不是立即跳转到目标位置。它创建了一个平滑的动画效果，使用户体验更加友好。
        left: 0,
        top: (hArr[index].offsetTop + 520) * this.$store.state.roomNum,
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
$conMinWidth: 1200px;
.pageCon {
  min-width: 1470px;
  background-color: #f9f9f9;
}

.modelpaddingTop {
  padding-top: 50px;
}
.pabo50 {
  padding-bottom: 50px;
}
.whiteBg {
  background-color: white;
}

.logisticsInputBox {
  border-radius: 4px;
  width: 150px;
  /deep/.el-input__inner {
    border-right: none;
    border-color: #c0c4cc;
  }
  /deep/.el-input-group__append {
    background-color: white;
    color: #7d7f8f;
    font-size: 14px;
    border-color: #c0c4cc;
    padding-right: 16px;
  }
}
.logisticsInputBox.totalWeightInput {
  pointer-events: none;
  /deep/.el-input__inner {
    background-color: transparent;
  }
}

.bg1 {
  background-image: url("https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260616092322911681.png");
  background-size: 100% 100%;
  height: 560px;
  @extend .dip;
  .bg1Con {
    width: $conMinWidth;
    line-height: 1;
    color: #ffffff;
    h3 {
      font-size: 12px;
      color: #ffad00;
      letter-spacing: 2.2px;
      margin-bottom: 25px;
    }
    h1 {
      font-size: 26px;
      margin-bottom: 25px;
      letter-spacing: 0.2px;
    }
    .pBox {
      p {
        font-size: 16px;
        line-height: 28px;
      }
    }
  }
}

.fontModel {
  @extend .modelpaddingTop;
  @extend .dip;

  .modelCon {
    width: $conMinWidth;
    .fontConTitle {
      height: 56px;
      @extend .dip;
      margin-bottom: 26px;
      span {
        font-size: 24px;
        margin-right: 60px;
        line-height: 56px;
      }
      .line {
        height: 1px;
        background-color: #b4b4b4;
        flex: 1;
      }
    }

    .tableBox {
      margin-bottom: 0;
      .tul {
        .tli {
          border: none !important;
          padding: 20px 0;
        }

        .tli.ttt {
          background: none;
          height: 53px;
          font-weight: 500;
          font-size: 13px;
          color: #7d7f8f;
          letter-spacing: 2.6px;
        }
        .tli.tbo {
          min-height: 68px;
          color: #808191;
          font-size: 16px;
        }

        .tli.fontWeight500 {
          font-weight: 500;
          color: #000000;
        }
      }
      .tul.ttt {
        background-color: #f0f3f6;
        border-radius: 6px;
      }
      .tul.tbo {
        background-color: white;
      }
      .tul.tbo:nth-child(2n-1) {
        background-color: #f9f9fb;
      }
    }

    .whiteCard {
      background-color: white;
      margin-bottom: 30px;
      border-radius: 4px;
      &:last-child {
        margin-bottom: 0;
      }
      padding: 10px 23px;
      .logisticsNameBox {
        font-weight: bold;
        font-size: 30px;
        line-height: 56px;
        margin-bottom: 10px;
      }
    }

    .showLositiTable {
      .tul {
        padding: 0 30px;
      }
    }

    .calculateLogisticsTable {
      margin-bottom: 30px;

      .addRow {
        @extend.dip;
        justify-content: space-between;
        padding: 0 20px;
        height: 68px;
        background: #f9f9fb;
        border: 1px solid #f0f3f6;
        .el-button {
          border-radius: 4px;
          height: 42px;
          min-width: 100px;
          padding: 0 12.5px;
        }
        // 与设计稿「Calcola costi」一致：主色按钮圆角 12px
        .el-button.bgBlueBtn {
          border-radius: 12px;
        }
        // 与设计稿「Aggiungi」一致：品牌色/特殊按钮 #78B719，白字，圆角 10px
        .el-button.bgGreenBtn {
          height: 44px;
          min-width: auto;
          padding: 12px 16px;
          border-radius: 10px;
          background-color: #78b719;
          border-color: #78b719;
          color: #ffffff;
          font-size: 14px;
          font-weight: 700;
          line-height: 20px;

          &:hover,
          &:focus {
            background-color: #6da316;
            border-color: #6da316;
            color: #ffffff;
          }
        }
        .totalBox {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }

    .calculationResultsTable {
      .tul {
        border: 1px solid #f0f3f6;
        margin-top: -1px;
        .tli {
          padding: 20px 10px;
        }
        .tli.ttt {
          text-align: center;
          letter-spacing: 2.2px;
          line-height: 1.1;
        }
        .tli.tbo {
          font-size: 16px;
          color: #000000;
          white-space: pre-line;
        }

        .logisticsNameColorBox {
          @extend .dip;
          width: 100%;
          border-radius: 4px;
          height: 40px;
          font-weight: 600;
          font-size: 14px;
        }
        .aLink {
          font-weight: 600;
          font-size: 14px;
          color: #009246;
          text-decoration: none;
        }
        .texcen {
          text-align: center;
          word-break: normal;
        }
      }
    }

    .fontConTip {
      padding: 30px 30px 15px 30px;
      font-size: 15px;
      color: #808191;
      line-height: 26px;
      .aLink {
        color: #009246;
        text-decoration: none;
      }
    }

    .logisticsPriceList {
      margin-bottom: 15px;
      .tul {
        width: max-content;
        background-color: white;
        .tli.tbo {
          flex: unset;
          color: #000000;
          border-color: #f0f3f6;
          min-height: 68px;
          font-weight: 500;
          width: 200px;
        }
        .tli.tbo.blueTbo {
          background: #78b719;
          color: white;
          width: 160px;
        }
      }
    }

    .lastUpdatedDate {
      line-height: 18px;
      font-size: 14px;
      color: #808191;
      margin-bottom: 27px;
    }

    .deliveryTime {
      width: 240px;
      height: 42px;
      background: #eaf8e8;
      border-radius: 21px;
      @extend .dip;
      font-size: 16px;
      color: #009246;
      margin-bottom: 26px;
      span {
        font-weight: 600;
        margin-right: 14px;
      }
    }

    .mattersNeedingAttention {
      font-size: 16px;
      color: #000000;
      line-height: 24px;
      margin-bottom: 15px;
    }
  }
}

.expertAgent {
  width: 1200px;
  height: 451.08px;
  background-color: #f8f9fa;
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s;
  @extend .fdcolmun;
  justify-content: center;
  svg {
    width: 40px;
    height: 40px;
    display: block;
    margin: 0 auto;
    fill: #99aef0;
  }
  .expertAgentCon {
    width: 660px;
    padding: 10px;
    margin: 0 auto;
    > * {
      text-align: center;
    }
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    > div:first-child {
      font-size: 21px;
      font-weight: 500;
      line-height: 1.5em;
      margin-bottom: 10px;
    }
    p {
      width: 660px;
      font-size: 16px;
      font-weight: 400;
      line-height: 1.8em;
      margin-bottom: 34px;
    }
    button {
      // 与设计稿「Contatta un agente」一致：品牌色/主色 #009246，白字，圆角 12px
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      width: 337px;
      height: 60px;
      padding: 20px 80px;
      border-radius: 12px;
      border: none;
      background: #009246;
      color: #ffffff;
      transition: background-color 0.3s;
      cursor: pointer;
      &:hover {
        background-color: #2a6418;
        color: #ffffff;
      }
    }
  }
}

.color1 {
  background: #eaf8e8;
  color: #009246;
}
.color2 {
  background: #e7fafb;
  color: #0e8f5a;
}
.color3 {
  background: #eaffef;
  color: #2ec353;
}
.color4 {
  background: #fff4e8;
  color: #ffa81e;
}
.color5 {
  background: #fceefe;
  color: #d71ae8;
}
.color6 {
  background: #fefaee;
  color: #e8a71a;
}
.color7 {
  background: #fef2ee;
  color: #e85b1a;
}
</style>
